module.exports = __webpack_public_path__ + "img/sm-icon.2b9bbf20.png";